import { Button } from '@mui/material';
import React, { useState, useEffect, useContext } from 'react';
import QRCode from 'react-qr-code';
import ConnectYourRoom from './ConnectYourRoom';
import { randomInt } from 'crypto';
import ControllerContext from '../../../RoomControllerSocketContext';
import { useHistory } from 'react-router-dom';
const { electron } = window;

const PairController = () =>
{

	const [ connect, setConnect ] = useState(false);
	const { pluginSocket } = useContext(ControllerContext);
	const [ randomNumber, setRandomNumber ] = useState('');
	const [ minutes, setMinutes ] = useState(2);
	const [ seconds, setSeconds ] = useState(0);
	const [ desktopId, setDesktopId ] = useState('');
	const history = useHistory();

	const handleConnect = () =>
	{
		// setConnect(true);
	};

	const getMachineId = async () =>
	{
		const machineId = await window?.electron?.ipcRenderer?.invoke('getMachineId');

		if (machineId)
		{
			setDesktopId(machineId);
		}
	};

	async function getTokenData()
	{
		const tokenData = await window?.electron?.ipcRenderer?.invoke('getTokenData', 'token');
		const roomName = await window?.electron?.ipcRenderer?.invoke('getRoomData', 'roomName');
		const joinData = await window?.electron?.ipcRenderer?.invoke('requestToJoinRoom');

		console.log('join data on socket connect===', joinData);

		console.log('TOKENdATA------------------------', tokenData);
		if ((tokenData && !roomName) || (joinData?.controllerUniqueId))
		{
			// setConnect(true);
		}
	}

	useEffect(() =>
	{
		getMachineId();
		// getTokenData();
		setRandomNumber(generateRandomNumber());
	}, []);

	useEffect(() =>
	{
		pluginSocket?.on('checkPairCode', async (data) =>
		{
			console.log('checkPairCoode data==', data);
			const controllerSocketId = await window?.electron?.ipcRenderer?.invoke('getTokenData', 'controllerSocketId');

			if (controllerSocketId)
			{
				pluginSocket?.emit('roomPairingStatus', { status: false, userSocketId: data.userSocketId, message: 'Please wait another controller is pairing to this room' });
			}
			else
			if (data?.code && data?.userSocketId)
			{
				window?.electron?.ipcRenderer?.sendMessage('storeData', { key: 'controllerSocketId', value: data.userSocketId });
				console.log('data code type==', typeof code);
				if (data.code == randomNumber)
				{

					// /////////////////////// Need to Store the paired device status////////////////////////////////
					const machineId = await window?.electron?.ipcRenderer?.invoke('getMachineId');

					pluginSocket?.emit('roomPairingStatus', { status: true, desktopUniqueId: machineId, controllerUniqueId: data.controllerUniqueId, userSocketId: data.userSocketId, code: data?.code });
					window?.electron?.ipcRenderer?.sendMessage('storeData', { key: 'controllerUniqueId', value: data.controllerUniqueId });
					window?.electron?.ipcRenderer.invoke('disconnectingroom', { key: 'controllerSocketId' });
					history.push('/controllerPair');
					// setConnect(true);
				}
				else
				{
					window?.electron?.ipcRenderer.invoke('disconnectingroom', { key: 'controllerSocketId' });
					pluginSocket?.emit('roomPairingStatus', { status: false, userSocketId: data.userSocketId, message: 'Invalid Code.' });
				}
			}
		});

		return () =>
		{
			pluginSocket?.off('checkPairCode');
			pluginSocket?.off('roomPairingStatus');
		};
	}, [ pluginSocket, randomNumber ]);

	useEffect(() =>
	{
		if (randomNumber && desktopId && pluginSocket)
		{
			// get previous code from local storage
			const prevCode = localStorage.getItem('previousCode');

			console.log('desktopIddddd', desktopId);

			pluginSocket?.emit('desktopCode', { code: randomNumber, desktopUniqueId: desktopId, previousCode: prevCode });
		}

		pluginSocket?.on('isRoomExists', (data) =>
		{
			console.log('isRoomExists===', data);
			console.log('type====', typeof data);
			if (data)
			{
				setMinutes(2);
				setSeconds(0);
				setRandomNumber(generateRandomNumber());
			}
		});

		return () =>
		{
			pluginSocket?.off('desktopCode');
			pluginSocket?.off('isRoomExists');
		};
	}, [ randomNumber, desktopId, pluginSocket ]);

	useEffect(() =>
	{
		const intervalId = setInterval(() =>
		{

			if (seconds === 0)
			{
				if (minutes === 0)
				{

					setMinutes(2);
					setSeconds(0);
					const newRandomNumber = generateRandomNumber();

					console.log('newRandomNumber newRandomNumber===', newRandomNumber);
					localStorage.setItem('previousCode', randomNumber);
					setRandomNumber(newRandomNumber);
					// save in local storage
				}
				else
				{

					setMinutes(minutes - 1);
					setSeconds(59);
				}

			}
			else
			{
				setSeconds(seconds - 1);
			}
		}, 1000);

		// if (intervalId)
		// {
		// 	clearInterval(intervalId);
		// }

		return () => clearInterval(intervalId);
	}, [ minutes, seconds ]);

	function generateRandomNumber()
	{
		const newRandomNumber = Math.floor(Math.random() * 1000000).toString()
			.padStart(6, '0');

		return newRandomNumber;
	}

	return (
		<>
			{/* {connect === false ? */}
			<div className='flexCol pdngTLG jCntr'>
				<span className='cnnctRoom wTxt desrespad'>Pair with controller</span>
				<span className='instructions desrespad'>Scan the QR code or go to the app store to download the Inmeet Meeting Rooms Controller app</span>
				<span className='instructions desrespad'>Enter the 6-digit code within the Rooms Controller application</span>
				<div className='flexRow idcolor desrespad'>
					<span className='pdngRSM reloadnumber'>{randomNumber?.charAt(0)}</span>
					<span className='pdngHMD reloadnumber'>{randomNumber?.charAt(1)}</span>
					<span className='pdngHMD reloadnumber'>{randomNumber?.charAt(2)}</span>
					<span className='pdngHMD reloadnumber'>{randomNumber?.charAt(3)}</span>
					<span className='pdngHMD reloadnumber'>{randomNumber?.charAt(4)}</span>
					<span className='pdngHMD reloadnumber' >{randomNumber?.charAt(5)}</span>
				</div>
				<div className='flexAutoRow'>
					<div className='flexMinWidthRow'>
						<span className='txt20 idcolor desrespad'>This code will expire in <span className='timecolour'>{`0${minutes}:${seconds < 10 ? '0' : ''}${seconds}`}</span> minutes</span>
					</div>
					<div className='flexAutoRow pdngRLG'>
						<div className='whiteBg pdngXS'>
							<QRCode
								size={256}
								style={{ height: 'auto', maxWidth: 184, width: '100%' }}
								value={randomNumber}
								viewBox={'0 0 256 256'}
								// onClick={handleConnect}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default PairController;